export default __webpack_public_path__ + "static/media/service.055cb0d5.webp";